import { render } from "./WizardStep3.vue?vue&type=template&id=1b61e94a"
import script from "./WizardStep3.vue?vue&type=script&lang=js"
export * from "./WizardStep3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardStep3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b61e94a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b61e94a', __exports__)) {
    api.reload('1b61e94a', __exports__)
  }
  
  module.hot.accept("./WizardStep3.vue?vue&type=template&id=1b61e94a", () => {
    api.rerender('1b61e94a', render)
  })

}


export default __exports__